module.exports = "mutation UpdateTransportContract($data:[UpdateTransportContractInput]!){updateTransportContract(data:$data){success}}"